/**
 * Extrai a mensagem de erro de uma resposta da API.
 *
 * O backend responde `{ error: "..." }` nas falhas. Este helper devolve
 * essa mensagem, ou um texto de fallback quando o corpo não é JSON.
 *
 * @param {Response} resp
 * @returns {Promise<string|null>} null quando a resposta foi bem-sucedida
 */
export async function extrairErro(resp) {
  if (!resp) return 'Sem resposta do servidor';
  if (resp.ok) return null;

  try {
    const dados = await resp.json();
    if (dados && dados.error) return dados.error;
  } catch (e) {
    // corpo vazio ou não-JSON — cai no fallback
  }

  return `Erro ${resp.status || ''}`.trim();
}

export default extrairErro;
